export default __webpack_public_path__ + "static/media/krzyzowka_3.d20ce6a6.jpg";